import React, { Suspense, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";
import Cookies from 'universal-cookie';

import 'semantic-ui-css/semantic.min.css'
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap/dist/css/bootstrap.min.css";
import './locales/multiplelangSupport'
import "./assets/fonts/fonts.scss";
import "bootstrap/dist/js/bootstrap"
import "./assets/styles/main.scss";
import './components/styles/theme-provider.scss'

import { ToastContainer } from 'react-toastify';
import LoginLayout from "./pages/login/LoginLayout";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import AppContainer from "./pages/AppContainer";
import NavigationBlocker from "./pages/products/addProduct/NavigationBlocker";
import { PersistGate } from 'redux-persist/integration/react'
import Swagger from "./pages/swaggerApi/Swagger";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const AppLayout = ({ shouldBlockNavigation }) => {
  const theme = createTheme({
    spacing: 4,
    // Add other theme configurations here
  });

  return (
    <>
      {/* Only render the blocker when we should block navigation */}
      {/* <NavigationBlocker 
        when={shouldBlockNavigation} 
        message={{ content: "You have unsaved changes. Are you sure you want to leave?" }}
      /> */}
      <ThemeProvider theme={theme}>
        <Outlet />
      </ThemeProvider>
    </>
  );
};

function AppRoute() {
  // This state would be set to true when there are unsaved changes
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(true);
  const cookies = new Cookies();

  const PrivateRoute = () => {
    const _authState = cookies.get('AUTH_STATE');
    console.log("auth state in private route: ", _authState);
    return _authState ? <Outlet /> : <Navigate replace to="/login" />;
  };

  const router = createBrowserRouter([
    {
      element: <AppLayout shouldBlockNavigation={shouldBlockNavigation} />,
      children: [
        {
          path: "/login",
          element: <LoginLayout />
        },
        {
          path: "/signup",
          element: <LoginLayout />
        },
        {
          path: "/unsubscribe",
          element: <LoginLayout />
        },
        {
          path: "/terms",
          element: <LoginLayout />
        },
        {
          path: "/resetpassword",
          element: <LoginLayout />
        },
        {
          path: "/newpassword",
          element: <LoginLayout />
        },
        {
          path: "/swagger/public",
          element: <Swagger />
        },
        {
          element: <PrivateRoute />,
          children: [
            {
              path: "/*",
              element: <AppContainer />
            }
          ]
        }
      ]
    }
  ]);

  return (
    <>
      <Suspense fallback={<div>Loading....</div>}>
        <Provider store={store}>
          <ToastContainer />
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider router={router} />
          </PersistGate>
        </Provider>
      </Suspense>
    </>
  );
}

export default AppRoute